import styled, { ColorName } from 'styled-components';

import { BaseWaves } from '~/src/common/components/Logo';
import { media } from '~/src/styles-constants';

const Variants: Record<string, [ColorName, ColorName]> = {
  NORMAL: ['PRIMARY', 'WHITE'], // Vert sur blanc
  INVERT: ['WHITE', 'PRIMARY'], // Blanc sur vert
};

const Sizes: Record<string, number> = {
  SM: 10,
  MD: 12,
  LG: 14,
};

export const Container = styled.div<{ $variant?: string }>`
  display: flex;
  justify-content: center;

  ${({ theme, $variant = 'NORMAL' }) => {
    const colors = ($variant && Variants[$variant]) || Variants.NORMAL;
    const [foreground, background] = colors;
    return `
      color: ${theme.palette.common[foreground]};
      background: ${theme.palette.common[background]};
    `;
  }}

  ${media.M`
    padding: 0px 24px;
  `}
`;

export const Waves = styled(BaseWaves)<{ $size?: string }>`
  display: block;

  ${({ $size = 'MD' }) => {
    const height = ($size && Sizes[$size]) || Sizes.MD;
    return `
      height: ${height}px !important;
      margin: ${height * 1.5}px 0;
    `;
  }}
`;
